import { Element, useNode } from "@craftjs/core";

import TopLevelFloatingOptions from "@/components/editor/block-outline/floating-options/top-level-floating-component";
import Video from "@/components/editor/primitives/video/video-component";
import {
  BlockBackgroundColorWrapper,
  BlockMaxWidthWrapper,
  BlockPaddingWrapper,
} from "@/components/editor/shared/block-wrapper";

import ParagraphItem from "../../sections/paragraph-picture/paragraph-item-component";
import VideoWithParagraphList from "./video-with-paragraph-list-component";

export default function VideoWithParagraph() {
  const {
    id,
    connectors: { connect },
  } = useNode();

  return (
    <BlockBackgroundColorWrapper ref={connect} id={id}>
      <BlockPaddingWrapper>
        <BlockMaxWidthWrapper>
          <Element id="list-container" is={VideoWithParagraphList} canvas>
            <Element
              id="title"
              is={ParagraphItem}
              subTitle="<h4>Three days of interviews</h4>"
              description="<p>Over three days of unscripted interviews and interactive workshops, attendees with an eye on emerging trends will hear from and collaborate with entrepreneurs, artists, athletes, scientists and thinkers for a first look at the seismic shifts occurring in the way we live, work and play.</p>"
            />
            <Element id="video" is={Video} url="https://youtu.be/9m4oFnBLTos" />
          </Element>
        </BlockMaxWidthWrapper>
      </BlockPaddingWrapper>
    </BlockBackgroundColorWrapper>
  );
}

VideoWithParagraph.craft = {
  custom: {
    displayName: "Video with paragraph",
  },
  related: {
    leftOutlineOptions: TopLevelFloatingOptions,
  },
};
